import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/GridLegacy';
import { useContext, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { useRetrieveAccessTokenQuery } from '../../apiClients/identityClient/requests/AccessTokenApi';
import { LOGIN_ERROR_ROUTE, LOGIN_ORG_ROUTE } from '../../constants';
import { clearLoginError } from '../../store/localStorageHelpers/loginErrorHelper';
import { getCSRFState } from '../../store/sessionStorageHelpers/authStateHelpers';
import { Background } from '../background/Background';
import { LoginContext } from '../loginHandler/LoginContext';
export function RetrieveAccessToken({ authCode, includeClientSecret, forceOauthPrefix, }) {
    const navigate = useNavigate();
    const { data, error } = useRetrieveAccessTokenQuery({
        authCode,
        includeClientSecret,
        forceOauthPrefix,
    });
    useEffect(() => {
        var _a, _b;
        if (data) {
            navigate(LOGIN_ORG_ROUTE);
        }
        if (error) {
            const errorMessage = ((_a = error === null || error === void 0 ? void 0 : error.data) === null || _a === void 0 ? void 0 : _a.error) || 'unable_to_get_access_token';
            const errorDescription = ((_b = error === null || error === void 0 ? void 0 : error.data) === null || _b === void 0 ? void 0 : _b.error_description) || '';
            navigate(`${LOGIN_ERROR_ROUTE}?error=${errorMessage}&error_description=${errorDescription}`);
        }
    }, [data, error]);
    return (_jsx(Background, { children: _jsx(Grid, { item: true, style: {
                position: 'relative',
                width: '100%',
                height: '100px',
            }, alignContent: "center", justifyContent: "center", display: "grid", children: _jsx(CircularProgress, {}) }) }));
}
export function LoginSuccess() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { includeClientSecret, forceOauthPrefix } = useContext(LoginContext);
    const authCode = searchParams.get('code');
    const state = searchParams.get('state');
    const storedState = getCSRFState();
    clearLoginError();
    useEffect(() => {
        if (state !== storedState) {
            navigate(`${LOGIN_ERROR_ROUTE}?error=invalid_auth_state`);
        }
    }, []);
    useEffect(() => {
        if (!authCode) {
            navigate(`${LOGIN_ERROR_ROUTE}?error=no_auth_token`);
        }
    }, [authCode]);
    return (_jsx(_Fragment, { children: authCode && state === storedState && (_jsx(RetrieveAccessToken, { authCode: authCode, includeClientSecret: includeClientSecret, forceOauthPrefix: forceOauthPrefix })) }));
}
//# sourceMappingURL=LoginSuccess.js.map